/* eslint-disable no-script-url */
/* eslint-disable no-control-regex */

// Taken from https://github.com/facebook/react/blob/546fe4681c52de6a333a55cedb141c87b626425e/packages/react-dom-bindings/src/shared/sanitizeURL.js
// A javascript: URL can contain leading C0 control or \u0020 SPACE,
// and any newline or tab are filtered out as if they're not part of the URL.
// https://url.spec.whatwg.org/#url-parsing
// Tab or newline are defined as \r\n\t:
// https://infra.spec.whatwg.org/#ascii-tab-or-newline
// A C0 control is a code point in the range \u0000 NULL to \u001F
// INFORMATION SEPARATOR ONE, inclusive:
// https://infra.spec.whatwg.org/#c0-control-or-space
const isJavaScriptProtocol =
  /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;

const sanitizeUrl = (url: string) =>
  isJavaScriptProtocol.test(url)
    ? 'javascript:throw new Error("Webflow has blocked a javascript: URL as a security precaution.")'
    : url;

const isUrlProp = (name: string) =>
  name === 'src' ||
  name === 'href' ||
  name === 'action' ||
  name === 'formaction' ||
  name === 'xlinkhref';

/**
 * Sanitizes prop values for React dom elements.
 *
 * To be used for props for which the value comes from user-input or untrusted
 * sources.
 *
 * ⚠️ This function is not safe to use outside of React!
 *
 * - Replaces javascript: URLs with a benign one
 * - Removes srcDoc prop (found on iframe)
 *
 */
export const sanitizeProp = (propName: string, value: string) => {
  // Extra resilience for the propName not existing, do not remove
  // this nor change the TS types.
  if (propName == null) return '';

  const name = propName.toLowerCase();

  if (isUrlProp(name)) return sanitizeUrl(value);

  if (name === 'srcdoc') return '';

  return value;
};
